// extracted by mini-css-extract-plugin
export default {"question":"Question_question__aFgvL","name":"Question_name__aT4R1","error":"Question_error__JO0o3","checkboxContainer":"Question_checkboxContainer__SIdz9"};